<div class="dropdown-root">
  @if (!searchQuery.trim()) {
    <div class="suggestion-section">
      <span class="suggestion-label">Common Conditions</span>
      <div class="suggestion-chips">
        @for (condition of prioritizedConditions(); track condition.name) {
          <button type="button" class="suggestion-chip condition-chip" (mousedown)="selectCondition(condition, $event)">
            <span class="chip-dot" [style.background]="condition.color"></span>
            {{ condition.name }}
          </button>
        }
      </div>
    </div>

    <div class="suggestion-section">
      <span class="suggestion-label">Popular Symptoms</span>
      <div class="suggestion-chips">
        @for (symptom of defaultSymptoms; track symptom) {
          <button type="button" class="suggestion-chip symptom-chip" (mousedown)="selectSymptom(symptom, $event)">
            {{ symptom }}
          </button>
        }
      </div>
    </div>

    @if (context === 'community' && currentCommunity() && communityTopics().length > 0) {
      <div class="suggestion-section">
        <span class="suggestion-label">In {{ currentCommunity()?.name }}</span>
        <div class="suggestion-chips">
          @for (topic of communityTopics(); track topic.slug) {
            <button type="button" class="suggestion-chip topic-chip" (mousedown)="navigateToTag(topic, $event)">
              # {{ topic.name }}
            </button>
          }
        </div>
      </div>
    }

    @if (recentSearches().length > 0) {
      <div class="suggestion-section">
        <div class="suggestion-label-row">
          <span class="suggestion-label">Recent Searches</span>
          <button type="button" class="clear-recent" (mousedown)="clearRecentSearches($event)">Clear</button>
        </div>
        <div class="recent-list">
          @for (term of recentSearches(); track term) {
            <button type="button" class="recent-item" (mousedown)="selectRecentSearch(term, $event)">
              <span class="recent-icon" aria-hidden="true">
                <mat-icon>history</mat-icon>
              </span>
              {{ term }}
            </button>
          }
        </div>
      </div>
    }
  } @else {
    @if (matchingCommunities().length > 0) {
      <div class="suggestion-section">
        <span class="suggestion-label">Communities</span>
        @for (community of matchingCommunities(); track community.id) {
          <button type="button" class="result-item" (mousedown)="navigateToCommunity(community, $event)">
            <span class="result-icon" [ngClass]="'community-tone-' + community.communityKey">
              <app-community-icon
                [community]="community.slug || community.name"
                source="communities"
                variant="outline"
                [size]="16"
              ></app-community-icon>
            </span>
            <span class="result-text">
              <span class="result-name" [innerHTML]="community.highlightedName"></span>
              <span class="result-meta">{{ community.memberCount }} members &middot; {{ community.postCount }} active</span>
            </span>
          </button>
        }
      </div>
    }

    @if (matchingTags().length > 0) {
      <div class="suggestion-section">
        <span class="suggestion-label">Topics</span>
        @for (tag of matchingTags(); track tag.slug + '-' + tag.communityId) {
          <button type="button" class="result-item" (mousedown)="navigateToTag(tag, $event)">
            <span class="result-tag-icon">#</span>
            <span class="result-text">
              <span class="result-name" [innerHTML]="tag.highlightedName"></span>
              <span class="result-meta">in {{ tag.communityName }} &middot; {{ tag.usageCount }} posts</span>
            </span>
          </button>
        }
      </div>
    }

    @if (matchingPosts().length > 0) {
      <div class="suggestion-section">
        <span class="suggestion-label">Discussions</span>
        @for (post of highlightedMatchingPosts(); track post.id) {
          <button type="button" class="result-item" (mousedown)="navigateToPost(post, $event)">
            <span class="result-post-icon" aria-hidden="true">
              <mat-icon>chat_bubble_outline</mat-icon>
            </span>
            <span class="result-text">
              <span class="result-name" [innerHTML]="post.highlightedTitle"></span>
              <span class="result-meta">by {{ post.authorName }} &middot; {{ post.replyCount }} replies</span>
            </span>
          </button>
        }
      </div>
    }

    @if (isSearching()) {
      <div class="suggestion-section">
        <p class="search-status">Searching...</p>
      </div>
    }

    @if (showNoResults()) {
      <div class="no-results">
        <p class="no-results-text">No results for "{{ searchQuery }}"</p>
        <p class="no-results-hint">Try a condition, symptom, topic, or discussion title.</p>
      </div>
    }
  }
</div>
